
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericMediumOutlined as ObiVesselGenericMediumOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-medium-outlined.js';
 
 
 

 
 export const ObiVesselGenericMediumOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-medium-outlined',
   elementClass: ObiVesselGenericMediumOutlinedElement,
   events: {
     
   }
  });
 
 